import { render, staticRenderFns } from "./HeaderNew.vue?vue&type=template&id=145f4773&scoped=true"
import script from "./HeaderNew.vue?vue&type=script&lang=js"
export * from "./HeaderNew.vue?vue&type=script&lang=js"
import style0 from "./HeaderNew.vue?vue&type=style&index=0&id=145f4773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f4773",
  null
  
)

export default component.exports